// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // <-- ¡Esto es importante!

const firebaseConfig = {
  apiKey: "AIzaSyCXixThKw1PZKnpKkMzeYnOsAeYRuah8cE",
  authDomain: "carnetados-f8c3c.firebaseapp.com",
  projectId: "carnetados-f8c3c",
  storageBucket: "carnetados-f8c3c.appspot.com",
  messagingSenderId: "816085388296",
  appId: "1:816085388296:web:de4eced42ed56b369015bd",
  measurementId: "G-7YR7T8QZ4P",
  // Añade la siguiente línea SOLO si la tienes en tu consola:
  databaseURL: "https://carnetados-f8c3c-default-rtdb.europe-west1.firebasedatabase.app"
  // La URL exacta te la da Firebase en la sección "Base de datos"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
